// Leads listening header helpers for Deepgram reconnect status strings.
// See docs/planning/deepgram_streaming_robustness.md §4 Q3.

import { AUDIO_DEVICE_CHANGED_STATUS } from "../../lib/asr/deepgramDeviceMonitor";

/** Engine emits `Reconnecting (attempt N/5)…` while auto-reconnect runs. */
export function isDeepgramReconnectingStatus(status: string): boolean {
  return status.startsWith("Reconnecting (attempt ");
}

/** Non-reconnect statuses worth surfacing in the Listening header pill. */
export function isDeepgramAsrFallbackStatus(status: string): boolean {
  return (
    status === AUDIO_DEVICE_CHANGED_STATUS ||
    status === "Reconnecting failed – tap mic to retry." ||
    status === "Disconnected – tap to reconnect" ||
    status === "Failed to start – check config"
  );
}
